import React, { useEffect } from "react";
import "./AppModal.scss";

interface AppModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  eyebrow?: string;
  description?: string;
  icon?: React.ReactNode;
  onSubmit?: () => void;
  submitLabel?: string;
  cancelLabel?: string;
  showFootNote?: boolean;
  submitDisabled?: boolean;
  maxWidth?: number;
  children: React.ReactNode;
}

const AppModal: React.FC<AppModalProps> = ({
  open,
  onClose,
  title,
  eyebrow,
  description,
  icon,
  onSubmit,
  submitLabel = "Sačuvaj",
  cancelLabel = "Otkaži",
  showFootNote = true,
  submitDisabled = false,
  maxWidth = 560,
  children,
}) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="am-backdrop"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="am-modal" style={{ maxWidth }}>
        <header className="am-head">
          {icon && <span className="am-ic">{icon}</span>}
          <div className="am-head-meta">
            {eyebrow && <div className="am-eyebrow">{eyebrow}</div>}
            <h2 className="am-title">{title}</h2>
            {description && <div className="am-desc">{description}</div>}
          </div>
          <button className="am-close" onClick={onClose} aria-label="Zatvori">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
          </button>
        </header>

        <div className="am-body">{children}</div>

        <footer className="am-foot">
          {showFootNote && (
            <span className="am-foot-note">
              <span className="am-req">*</span> Obavezno polje
            </span>
          )}
          <div className="am-foot-spacer" />
          <button className="am-btn" onClick={onClose}>
            {cancelLabel}
          </button>
          {onSubmit && (
            <button
              className="am-btn am-btn-primary"
              onClick={onSubmit}
              disabled={submitDisabled}
            >
              {submitLabel}
            </button>
          )}
        </footer>
      </div>
    </div>
  );
};

export default AppModal;
